import customRules from './rules';
import { configure, defineRule } from 'vee-validate';
import fa from '@vee-validate/i18n/dist/locale/fa.json';
import { localize, setLocale } from '@vee-validate/i18n';
import { all } from '@vee-validate/rules';

const addRulesToVeeValidate = (rules) => {
	Object.entries(rules).forEach(([ruleName, ruleFunction]) => {
		defineRule(ruleName, ruleFunction);
	});
};

export default {
	name: 'vee-validate',
	setup() {
		addRulesToVeeValidate(all);
		addRulesToVeeValidate(customRules);
		setLocale('fa');

		configure({
			validateOnBlur: false,
			validateOnInput: true,
			validateOnChange: false,
			generateMessage: localize({ fa }),
		});
	},
};
